angular.module('clients')
    .directive('clientAddressPicker', function ($filter, $document, $compile, $parse, Client) {
        return {
            restrict: 'E',
            require: 'ngModel',
            replace: true,
            scope: {
                clients: '='
            },
            templateUrl: "app/clients/client-address-picker/client-address-picker.html",
            link: function (scope, $element, $attrs, ngModelCtrl) {

                scope.inputSwitch = false;
                refreshClientAddresses(scope.clients);

                scope.$watchCollection(() => scope.clients, (newValue, oldValue) => {
                    if (oldValue !== newValue || oldValue === null) {
                        refreshClientAddresses(scope.clients);
                    }
                })

                function refreshClientAddresses(clients) {
                    scope.clientAddresses = [];
                    if(!angular.isArray(clients)) return;

                    clients.forEach(client => {
                        if(angular.isUndefined(client)) return;

                        Client.addresses({id:client.id}).$promise
                            .then(items => {
                                scope.clientAddresses.push({companySymbol: client.symbol, fullAddress: client.fullAddress});
                                items.forEach(singleAddress => {
                                    singleAddress.companySymbol = client.symbol;
                                    scope.clientAddresses.push(singleAddress);
                                });
                            });
                    });
                }

                scope.onSelect = ($item, $model) => {
                    scope.text = [$item.name,  $item.fullAddress]
                        .filter(it => it != null)
                        .filter(it => it.length > 0).join(", ");
                    scope.inputSwitch = false;
                    delete scope.uiNgModel;
                };

                scope.switchInput = bool => scope.inputSwitch = bool;

                // ngModelCtrl.$isEmpty = function (modelValue) {
                //     return !angular.isArray(modelValue) || modelValue.length === 0;
                // };
                ngModelCtrl.$render = () => scope.text = ngModelCtrl.$viewValue;
                ngModelCtrl.$formatters.push(modelValue => modelValue);
                ngModelCtrl.$parsers.push(viewValue => viewValue);
                ngModelCtrl.$validators.isValidState = (modelValue, viewValue) => !scope.inputSwitch;
                scope.$watch('text + inputSwitch', () => {
                    ngModelCtrl.$setViewValue(scope.text);
                    ngModelCtrl.$validate();
                    ngModelCtrl.$render();
                });
            }
        };
    })
